import { useTranslation } from "react-i18next";
import { type FieldErrorDto } from "../../../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../../../common/formatting/useDisplayDate";
import { useExtensionName } from "../../../../options/extensionName";
import { useContractState } from "../../../useContractState";

export const EXTENSIONS_OVERLAP = "zz_ContractApiErrorCode_ExtensionsOverlap";

export const useExtensionsOverlapExplanation = (): ((refusal: FieldErrorDto) => string) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const contractState = useContractState();
  const nameOf = useExtensionName(contractState.contract.dataFields.options ?? []);
  return (refusal) => {
    const params = refusal.params ?? {};
    return String(
      t("{{later}} would start on {{start}}, before {{earlier}} ends on {{end}}. It is not saved.", {
        later: nameOf({ id: params.laterId, name: params.laterName }),
        start: displayDate(params.laterStart ?? ""),
        earlier: nameOf({ id: params.earlierId, name: params.earlierName }),
        end: displayDate(params.earlierEnd ?? ""),
      })
    );
  };
};
